import { render } from "./add-source-modal.vue?vue&type=template&id=36fcc94b&scoped=true"
import script from "./add-source-modal.vue?vue&type=script&lang=js"
export * from "./add-source-modal.vue?vue&type=script&lang=js"

import "./add-source-modal.vue?vue&type=style&index=0&id=36fcc94b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36fcc94b"]])

export default __exports__